/* Big Apple BBQ ZIP checker (PLAN-LOCAL-DELIVERY rev 9). Copied to assets/bbq-zip-checker.js by
   delivery/theme-release.mjs. Vanilla JS, no libraries. Markup comes from snippets/bbq-zip-checker.liquid, which
   holds Henry's exact option text in <template> elements; this file only decides which template to show.
   The ZIP list is assets/bbq-delivery-zips.json, generated from delivery/zips-final.txt. */
(function () {
  'use strict';
  if (window.bbqZipChecker) return; // the snippet may render more than once per page

  function zip5(value) {
    var m = String(value == null ? '' : value).trim().match(/^(\d{5})(?:[-\s]?\d{4})?$/);
    return m ? m[1] : null;
  }

  var cache = {};
  function loadZips(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) { if (!d || !Array.isArray(d.zips) || !d.zips.length) throw new Error('bad ZIP list'); return new Set(d.zips); });
      cache[url].catch(function () { delete cache[url]; }); // allow a retry after a failed fetch
    }
    return cache[url];
  }

  function show(out, frag, text) {
    out.textContent = '';
    if (frag) { out.appendChild(frag); return; }
    var p = document.createElement('p');
    p.className = 'bbq-zip__message';
    p.textContent = text;
    out.appendChild(p);
  }

  function init(root) {
    if (root.getAttribute('data-bbq-zip-ready')) return;
    root.setAttribute('data-bbq-zip-ready', '1');
    var form = root.querySelector('form');
    var input = root.querySelector('input');
    var out = root.querySelector('[data-bbq-zip-result]');
    if (!form || !input || !out) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var zip = zip5(input.value);
      if (!zip) {
        input.setAttribute('aria-invalid', 'true');
        show(out, null, 'Enter a 5-digit ZIP code.');
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      show(out, null, 'Checking ZIP ' + zip + '…');
      loadZips(root.getAttribute('data-zips-url')).then(function (zips) {
        var tpl = root.querySelector(zips.has(zip) ? 'template[data-bbq-zip-in]' : 'template[data-bbq-zip-out]');
        var frag = tpl.content.cloneNode(true);
        Array.prototype.forEach.call(frag.querySelectorAll('[data-bbq-zip-value]'), function (n) { n.textContent = zip; });
        show(out, frag);
      }, function () {
        show(out, null, "We couldn't check that ZIP right now. Delivery options and pricing are shown at checkout.");
      });
    });
  }

  function initAll() { Array.prototype.forEach.call(document.querySelectorAll('[data-bbq-zip]'), init); }

  window.bbqZipChecker = { zip5: zip5, init: init, initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
